export const QueryStates = 'states';
export const QueryHotSpots = 'hotspots';
export const FetchAppParameters = 'fetch-app-parameters';
export const QueryContactTickets = 'contact-tickets';
export const QueryPatientTickets = 'patient-tickets';
export const QueryTickets = 'tickets';
export const GetTicketByNumber = 'ticket-by-number';
export const GetReviewsByTicketId = 'reviews-by-ticket-id';
export const QueryQuickConnects = 'quick-connects';
export const QueryQueueMetrics = 'queue-metrics';
export const GetRedirectLink = 'redirect-link';
export const QueryGetPatientById = 'patient-by-id';
export const GetPatientPhoto = 'patient-photo-by-patient-id';
export const GetPatientChartAlert = 'patient-chart-alert';
export const GetContactById = 'contact-by-id';
export const GetPatientAppointments = 'patient-appointments';
export const GetAppointmentType = 'appointment-type';
export const GetAppointmentTypes = 'appointment-types';
export const GetAppointmentTypesForPatient = 'appointment-types-for-patient';
export const GetAppointmentTypesForProvider = 'appointment-types-for-provider';
export const GetAppointmentSlots = 'appointment-slots';
export const GetCancellationReasons = 'cancellation-reasons';
export const GetCancellationReasonsEditable = 'cancellation-reasons-editable';
export const GetSecuritySettings = 'security-settings';
export const GetPracticeBranding = 'practice-branding';
export const GetPracticeEmailTemplate = 'practice-email-template';
export const GetSMSTemplates = 'sms-templates';
export const GetAppointmentReminders = 'appointment-reminders';
export const GetSMSTemplate = 'sms-template';
export const GetPatientClinical = 'get-patient-clinical';
export const GetPatientInsurance = 'get-patient-insurance';
export const GetPatientSummary = 'get-patient-summary';
export const GetDashboard = 'get-dashboard';
export const QueryContactsInfinite = 'contacts';
export const QueryContacts = 'query-contacts';
export const OneMinute = 60000;
export const FiveMinute = 5 * OneMinute;
export const QueryContactNotes = 'contact-notes';
export const QueryCompanyContacts = 'company-contacts';
export const QueryUserById = 'get-user';
export const UserListBaseData = 'user-list-base-data';
export const PreviewMedicalRecords = 'preview-medical-records';
export const GetLabResults = 'get-lab-results';
export const GetLabResultDetail = 'get-lab-result-detail';
export const GetLabResultDetailImage = 'get-lab-result-detail-image';
export const GetLabResultsProviderPicture = 'get-lab-results-provider-picture';
export const QueryPatientMedication = 'patient-medication';
export const QueryDefaultPharmacy = 'default-pharmacy';
export const QueryPharmacies = 'pharmacies';
export const CheckMedicalRecordStatus = 'check-medical-record-status';
export const GetTodaysPerformanceMetricsRequest = 'get-today-performance-metric';
export const GetAgentStatus = 'get-agents-status';
export const GetChatTranscript = 'get-chat-transcript';
export const QueryTicketMessageSummaryInfinite = 'ticket-message-summary';
export const QueryTicketMessageSummaryByTicketId = 'ticket-message-summary-ticket-id';
export const QueryTicketMessagesInfinite = 'ticket-messages';
export const GetTicketMessage = 'get-ticket-message';
export const SearchPatient = 'search-patient';
export const GetPatient = 'get-patient';
export const GetMessageTemplates = 'get-message-templates';
export const ProcessTemplate = 'process-template';
export const SearchContactResults = 'search-contact-results';
export const SearchTicketResults = 'search-ticket-results';
export const GetUserExtended = 'get-user-extended';
export const GetUserConnect = 'get-user-connect';
export const GetMobilePhone = 'get-mobile-phone';
export const SearchUserInActiveDirectory = 'search-user-in-active-directory';
export const GetUserList = 'get-user-list';
export const GetBlacklist = 'get-blacklist';
export const GetExternalUserList = 'get-external-user-list';
export const CheckPatientVerification = 'check-patient-verification';
export const CheckPatientIsExist = 'check-patient-exist';
export const CheckVerificationCode = 'check-verification-code';
export const GetCallLogs = 'get-calls-logs';
export const GetChatsLogs = 'get-chats-logs';
export const GetRecordedConversationLink = 'get-recorded-conversation-link';
export const GetRecordedConversationContent = 'get-recorded-conversation-content';
export const GetProviderPicture = 'get-provider-picture';
export const GetTicketsPerformanceForUser = 'get-tickets-performance-for-user';
export const GetContactPerformanceForUser = 'get-contact-performance-for-user';
export const GetLatestManagerReviews = 'get-latest-manager-reviews';
export const GetOverallManagerRatingsForUser = 'get-overall-manager-ratings-for-user';
export const GetAppointmentById = 'get-appointment-by-id';
export const GetAppointmentNotes = 'get-appointment-notes';
export const ExportTicketList = 'export-ticket-list';
export const SplitTicket = 'split-ticket';
export const GetPatientRatings = 'get-patient-ratings';
export const GetPatientTicketRating = 'get-patient-ticket-rating';
export const GetUserDetail = 'get-user-details';
export const GetInternalQueues = 'get-internal-queues';
export const GetEmailsForNotifications = 'get-email-for-notification';
export const GetSmsForNotifications = 'get-sms-for-notification';
export const GetAppointmentTypeSummary = 'get-appointment-type-summary';
export const GetContactsNames = 'get-contacts-names';
export const GetEmailNotificationTemplates = 'get-email-notification-templates';
export const GetGeneralSetting = 'get-general-setting';
export const GetAgentReport = 'get-agent-report';
export const GetQueueReport = 'get-queue-report';
export const GetBotReport = 'get-bot-report';
export const GetPerformanceChart = 'get-performance-charts';
export const GetSystemReport = 'get-system-report';
export const GetPatientChartTabSettings = 'get-patient-chart-tabs';
export const GetPatientCases = 'get-patient-cases';
export const GetIsEmailBlocked = 'get-is-email-blocked';
export const GetIsSMSBlocked = 'get-is-sms-blocked';
export const GetRelatedTicketParent = 'get-related-ticket-parent';
export const GetChildrenTicketNumbers = 'get-children-ticket-numbers';
export const GetCallbackTicketCount = 'get-callback-ticket-count';
export const GetChatWidget = 'get-chat-widget';
export const GetTicketTypes = 'get-ticket-types';
export const GetIntents = 'get-intents';
export const GetTimeZones = 'get-timezones';
export const GetOperationSettings = 'get-operation-settings';
export const GetTicketPossiblePatients = 'get-ticket-possible-patients';
export const GetTicketPossibleContacts = 'get-ticket-possible-contacts';
export const GetTicketPossiblePatientsSMS = 'get-ticket-possible-patients-sms';
export const GetTicketPossibleContactsSMS = 'get-ticket-possible-contacts-sms';
export const GetOnlineRatingSettings = 'get-online-rating-settings';
export const GenerateCalendarLink = 'get-generate-calendar-link';